module.exports = __webpack_public_path__ + "img/bg_avatar_male_09.021b64ee.png";